import { Modal } from '@mui/material';
import { NewPaymentContext } from 'components/payment/payment.context';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ThreeDS2CheckoutSdk from 'pages/payments/threeds2-checkout-sdk/threeds2-checkout-sdk.component';
import { useOn3DSCheckoutSdkStatusUpdates } from 'pages/payments/threeds2-checkout-sdk/threeds2-checkout-sdk.hooks';
import * as S from './threeds2-modal.styles';
import SpreedlyCheckoutButtonsContext from 'pages/checkout/checkout-buttons-new/checkout-buttons-wrapper/spreedly-checkout-buttons/spreedly-checkout-buttons-container/spreedly-checkout-buttons-provider/spreedly-checkout-buttons.context';

const ThreeDS2Modal = () => {
  const { t } = useTranslation();
  const { initOrderResponse } = useContext(NewPaymentContext);
  const { threeDSTransactionToken, threeDS2ModalClose } = useContext(
    SpreedlyCheckoutButtonsContext,
  );
  const onStatusUpdate = useOn3DSCheckoutSdkStatusUpdates(threeDS2ModalClose);

  return (
    <Modal
      open={!!threeDSTransactionToken}
      onClose={threeDS2ModalClose}
      aria-labelledby={t('3ds2.modal.ariaLabelledBy')}
      aria-describedby={t('3ds2.modal.ariaDescribedBy')}
    >
      <S.Container>
        <ThreeDS2CheckoutSdk
          environmentKey={initOrderResponse?.attributes?.gatewayMerchantId}
          transactionToken={threeDSTransactionToken}
          onStatusUpdate={onStatusUpdate}
        />
      </S.Container>
    </Modal>
  );
};

export default ThreeDS2Modal;
